import React from 'react';
import { MultiSelectChangeEvent, MultiSelectProps } from "@progress/kendo-react-dropdowns";
import { diffArray, PuzzleTagField } from "puzzle";
import * as _ from "lodash";
import { Component } from "puzzle";
import { SUPPLIER } from "./Types";

export type STATE = {
  opened: boolean
}

export interface PROPS extends MultiSelectProps {
  toggleSupplierInGroup?: any
}

class SelectSuppliersTagField extends Component<PROPS, STATE> {
  tagField: any;
  state: STATE = {
    opened: false
  };

  /**
   * Sets isDelete to true if remove is possible
   *
   * @param item
   */
  setDeletedProperty = (item: any) => {
    if (item.removePossible) {
      item.isDeleted = true;
    }
    return item;
  };

  /**
   * @inheritDoc
   */
  onChange = (event: MultiSelectChangeEvent): void => {
    const previousValue = event.target.props.value;
    const currentValue = event.target.value;
    let lastModified = diffArray(currentValue, previousValue);

    if (_.isEmpty(lastModified)) {
      lastModified = diffArray(previousValue, currentValue);
      lastModified = lastModified.map(this.setDeletedProperty);//Intentionally used map+filter since reduce will not preserve a reference
      lastModified = lastModified.filter((item: SUPPLIER) => {
        let { removePossible, claimed, unclaimPossible } = item;
        if (removePossible && claimed) {
          removePossible = unclaimPossible;
        }
        return removePossible;
      });
    }

    this.props.onChange && this.props.onChange({ ...event, lastModified, currentValue, previousValue });
  };


  render() {
    return (
      <PuzzleTagField
        ref={(el: any) => this.tagField = el}
        allowCustom={true}
        opened={this.state.opened}
        onClose={() => this.setState({ opened: false })}
        onOpen={() => this.setState({ opened: true })}
        {...this.props}
        onChange={this.onChange}
      />
    );
  }
}

export default SelectSuppliersTagField;
